/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react'
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import classnames from 'classnames'
// @ts-ignore
import s from './DBPagination.css'
// @ts-ignore
import left from './left.svg'
// @ts-ignore
import right from './right.svg'

class DBPagination extends React.Component {
  static defaultProps = {
    defaultCurrent: 1,
    total: 200,
    pageSize: 10,
    pageBufferSize: 1,
    pageChange () {}
  }

  static PropTypes = {
    total: PropTypes.number.isRequired,
  }

  constructor (props) {
    super(props)
    this.state = {
      current: props.current || props.defaultProps || 1,
      pageTotal: Math.ceil(props.total / props.pageSize)
    }

    this.goToPage = this.goToPage.bind(this)
    this.renderPage = this.renderPage.bind(this)
    this.prev = this.prev.bind(this)
    this.next = this.next.bind(this)
  }

  componentDidUpdate (prevProps) {
    if (prevProps.total !== this.props.total) {
      this.setState({
        pageTotal: Math.ceil(this.props.total / this.props.pageSize)
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.current) {
      this.setState({
        current: nextProps.current,
      })
    } 
  }


  /**
   * 跳转指定页
   * @param {Number} num 
   */
  goToPage (num) {
    const pageSize = this.props.pageSize
    this.setState({
      current: num
    })

    this.props.pageChange({
      current: num,
      pageSize: pageSize
    })
  }

  prev () {
    const current = this.state.current
    if (current > 1) {
      this.goToPage(current - 1)
    }
  }

  next () {
    const {current, pageTotal} = this.state
    if (current < pageTotal) {
      this.goToPage(current + 1)
    }
  }

  calcList () {
    const pageBufferSize = this.props.pageBufferSize

    const {current, pageTotal} = this.state

    const nullPage = [{
      index: 0,
      isClick: false
    }]

    // 计算页数
    let pageList = Array(pageTotal).fill({}).map((item, index) => ({
      index: index + 1,
      isClick: true
    }))

    // 判断是否页数太多，如果太多使用省略号
    if (pageTotal > pageBufferSize * 2 + 3) {

      if (current >= pageTotal - pageBufferSize - 1) {
        pageList = pageList.slice(0, 1).concat(nullPage, pageList.slice(pageTotal - pageBufferSize * 2 - 2))
      } else if (current <= pageBufferSize + 2) {
        // 如果当前页面小于 第一页 + pageBufferSize + 本身
        pageList = pageList.slice(0, pageBufferSize * 2 + 2).concat(nullPage, pageList.slice(pageList.length - 1))
      } else {
        pageList = pageList.slice(0, 1).concat(nullPage, pageList.slice(current - pageBufferSize - 1, current + pageBufferSize), nullPage, pageList.slice(pageList.length - 1))
      }
    }

    return pageList
  }

  renderPage (item, index) {
    const current = this.state.current
    if (item.isClick) {
      return (
        <li key={index} className={classnames({
          [s.current]: current === item.index
        })}>
          <a onClick={() => this.goToPage(item.index)} href="javascript:;">
            {item.index}
          </a>
        </li>
      )
    } else {
      return <span className={s.ecl} key={index}>...</span>
    }
  }
  
  render() {
    const {current, pageTotal} = this.state
    const propCurrent = this.state.current
    const pageList = this.calcList()

    return (
      <ul className={s.root}>
        <li onClick={this.prev} className={classnames({
          [s.disabled]: current <= 1
        })}>
          <a>
            <img src={left} alt="<"/>
          </a>
        </li>
        {pageList.map(this.renderPage)}
        <li onClick={this.next} className={classnames({
          [s.disabled]: current >= pageTotal
        })}>
          <a><img src={right} alt=">"/></a>
        </li>

        <span>共{this.props.total}条</span>
      </ul>
    )
  }
}

export default withStyles(s)(DBPagination);



// WEBPACK FOOTER //
// src/components/DBPagination/DBPagination.js